import type { EnvVariablesValues } from '@innovamat/ga-features';
import type { RegionalConfigVariablesType } from '@innovamat/regional-config-variables';

export function initEnvVariables(
  regionalConfigVariables: RegionalConfigVariablesType
): EnvVariablesValues {
  return {
    // Regional config variables
    APOLLO_SERVER: regionalConfigVariables.apolloServer,
    API_USERS: regionalConfigVariables.apiUsers,

    // Import.meta.env.VITE_ variables
    VERSION: import.meta.env.VITE_VERSION as string,
    UNITY_BUILD: import.meta.env.VITE_UNITY_BUILD as string,
    WEBCONTENTS_URL: import.meta.env.VITE_WEBCONTENTS_URL as string,
    GEOLOCATION_API: import.meta.env.VITE_GEOLOCATION_API as string,
    MANAGER_NEXT: import.meta.env.VITE_MANAGER_NEXT as string,
    CORPORATE_IMAGE_URL: import.meta.env.VITE_CORPORATE_IMAGE_URL as string,
    GEOLOCATION_URL: import.meta.env.VITE_GEOLOCATION_URL as string,
    ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT as string,

    // Empty values
    CONFIG_CAT_KEY: '',
    CONFIG_CAT_CACHE_TIME: '',
    WEBAPP: '',
    INTEGROMAT_GET_CRM_SCHOOL: '',
    POEDITOR_API_URL: '',
    POEDITOR_API_TOKEN: '',
    POEDITOR_PROJECT_ID: '',
    RUDDERSTACK_APIKEY: '',
    RUDDERSTACK_URL: '',
    ITERABLE_APIKEY: '',
    INLINE_MANUAL: '',
    ORGANIZATIONS: '',
    API_PLATFORM: '',
    API_SOLVER_URL: '',
    INTEGROMAT_SESSION_ERROR: '',
    INTEGROMAT_SESSION_REVIEW: '',
    GOOGLE_CLIENT_ID: '',
    GOOGLE_SECRET: '',
    PREPR_GRAPHQL: '',
    INTEGROMAT_SAVE_CRM_DATA: '',
    MAKE_PRINTING_TOOL_URL: '',
    USERS_CLIENT_ID: '',
    STANDALONE_BUILD_DOMAIN: '',
  };
}
